var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"radarMap"}},[_c('div',{attrs:{"id":"aibenMap"}}),_c('div',{staticClass:"map-pos"},[_c('div',[_vm._v(_vm._s(_vm.total))]),_c('div',[_vm._v("健康值")])])])}
var staticRenderFns = []

export { render, staticRenderFns }